import * as types from "../actions/types";

const initialState = {
  loading: false,
  educDirections: [],
  newsLevels: [],
  eventTypes: [],
  eventForms: [],
  parallels: [],
  teachers: [],
  languages: [],
  // Личные дела учащихся
  specialistRecordSections: [],
  privileges: [],
  penaltyReasonVids: [],
  familyEthnicities: [],
  specialities: [],
  eduLessons: [],
  militaryDistricts: [],
  universities: [],
  deskNumbers: [],
  countries: [],
  rfSubjects: [],
  schools: [],
  rooms: [],
  eventRooms: [],
  socialGroups: [],
  physicalTrainingIndicators: [],
  achievementTypes: [],
  resultIncluding: [],
  severityLevels: [],
  milRanks: [],
  portfolioYears: [],
  availableOutCourses: [],
  availableXpCourses: [],
  availableCourses: [],
  availableOutGroups: [],
  availableSubgroups: [],
  availableXpGroups: [],
  availableClasses: [],
  examNames: [],
};

export default function library(state = initialState, action) {
  switch (action.type) {
    case types.SET_LIBRARY_LOADING:
      return { ...state, loading: action.payload };

    case types.SET_LIBRARY_EDUC_DIRECTIONS:
      return { ...state, educDirections: action.payload };

    case types.SET_LIBRARY_NEWS_LEVELS:
      return { ...state, newsLevels: action.payload };

    case types.SET_LIBRARY_EVENT_TYPES:
      return { ...state, eventTypes: action.payload };

    case types.SET_LIBRARY_EVENT_FORMS:
      return { ...state, eventForms: action.payload };

    case types.SET_LIBRARY_PARALLELS:
      return { ...state, parallels: action.payload };

    case types.SET_LIBRARY_TEACHERS:
      return { ...state, teachers: action.payload };

    case types.SET_LIBRARY_LANGUAGES:
      return { ...state, languages: action.payload };

    case types.SET_LIBRARY_SPECIALIST_RECORD_SECTIONS:
      return { ...state, specialistRecordSections: action.payload };

    case types.SET_LIBRARY_PRIVILEGES:
      return { ...state, privileges: action.payload };

    case types.SET_LIBRARY_PENALTY_REASON_VIDS:
      return { ...state, penaltyReasonVids: action.payload };

    case types.SET_LIBRARY_FAMILY_ETHNICITIES:
      return { ...state, familyEthnicities: action.payload };

    case types.SET_LIBRARY_SPECIALITIES:
      return { ...state, specialities: action.payload };

    case types.SET_LIBRARY_EDU_LESSONS:
      return { ...state, eduLessons: action.payload };

    case types.SET_LIBRARY_MILITARY_DISTRICTS:
      return { ...state, militaryDistricts: action.payload };

    case types.SET_LIBRARY_UNIVERSITIES:
      return { ...state, universities: action.payload };

    case types.SET_LIBRARY_DESK_NUMBERS:
      return { ...state, deskNumbers: action.payload };

    case types.SET_LIBRARY_COUNTRIES:
      return { ...state, countries: action.payload };

    case types.SET_LIBRARY_RF_SUBJECTS:
      return { ...state, rfSubjects: action.payload };

    case types.SET_LIBRARY_SCHOOLS:
      return { ...state, schools: action.payload };

    case types.SET_LIBRARY_ROOMS:
      return { ...state, rooms: action.payload };

    case types.SET_LIBRARY_EVENT_ROOMS:
      return { ...state, eventRooms: action.payload };

    case types.SET_LIBRARY_SOCIAL_GROUPS:
      return { ...state, socialGroups: action.payload };

    case types.SET_LIBRARY_PHYSICAL_TRAINING_INDICATORS:
      return { ...state, physicalTrainingIndicators: action.payload };

    case types.SET_LIBRARY_ACHIEVEMENT_TYPES:
      return { ...state, achievementTypes: action.payload };

    case types.SET_LIBRARY_RESULT_INCLUDING:
      return { ...state, resultIncluding: action.payload };

    case types.SET_LIBRARY_SEVERITY_LEVELS:
      return { ...state, severityLevels: action.payload };

    case types.SET_LIBRARY_MIL_RANKS:
      return { ...state, milRanks: action.payload };

    case types.SET_LIBRARY_PORTFOLIO_YEARS:
      return { ...state, portfolioYears: action.payload };

    case types.SET_LIBRARY_AVAILABLE_OUT_COURSES:
      return { ...state, availableOutCourses: action.payload };

    case types.SET_LIBRARY_AVAILABLE_XP_COURSES:
      return { ...state, availableXpCourses: action.payload };

    case types.SET_LIBRARY_AVAILABLE_COURSES:
      return { ...state, availableCourses: action.payload };

    case types.SET_LIBRARY_AVAILABLE_OUT_GROUPS:
      return { ...state, availableOutGroups: action.payload };

    case types.SET_LIBRARY_AVAILABLE_SUBGROUPS:
      return { ...state, availableSubgroups: action.payload };

    case types.SET_LIBRARY_AVAILABLE_XP_GROUPS:
      return { ...state, availableXpGroups: action.payload };

    case types.SET_LIBRARY_AVAILABLE_CLASSES:
      return { ...state, availableClasses: action.payload };

    case types.SET_LIBRARY_EXAM_NAMES:
      return { ...state, examNames: action.payload };
    case types.SET_LIBRARY_WEEKS:
      return { ...state, weeks: action.payload };

    default:
      return state;
  }
}
